export default "__VITE_ASSET__DqSydx$U__"